class AmenityAccordion {

	constructor() {
		this.active_category = null;
		this.amenity_categories = AM_LOCALIZED.accordion_categories;
		this.accordion_list = $(".amenity-accordion");
		this.handle_accordion_click();
		this.handle_amenity_click();
		this.build_html();
	}

	build_html() {
		for (var i in this.amenity_categories) {
			this.set_amenity_list(this.amenity_categories[i]);
		}
	}

	set_amenity_list(category_amenity_list) {
		if( !category_amenity_list.category ) {
			return;
		}
		var category_parent = this.accordion_list.find('#amenity-category-' + category_amenity_list.category.term_id);
		var html = '';
		for (var i in category_amenity_list.amenities) {
			var amenity = category_amenity_list.amenities[i];
			if (amenity.place_id) {
				this.get_place_id(amenity, category_parent);
			}
		}
	}

	get_place_id(amenity, category_parent) {
		var place_id = amenity.place_id;
		var return_place = null;

		category_parent.find('.sub-list').append('<li place-id="' + place_id + '" class="accordion-amenities__amenity amenity-list-item amenity-' + amenity.ID + '"><a class="amenity accordion-amenities__link" href="#"><span class="accordion-amenities__title">' + amenity.post_title + '</span><i class="inner-icon accordion-amenities__icon am-icon"></i></a><ul class="accordion-amenities__details accordion-details place-details"></ul></li>');
	}

	get_place_html(place) {
		var html = '';
		var address = typeof place.formatted_address !== "undefined" ? place.formatted_address : '';
		var phone = typeof place.formatted_phone_number !== "undefined" ? place.formatted_phone_number : '';
		var website = typeof place.website !== "undefined" ? place.website : '';
		var opening_hours = typeof place.opening_hours !== "undefined" ? place.opening_hours.weekday_text : '';
		var hours_string = '';
		for (var i = 0; i < opening_hours.length; i++) hours_string += '<li>' + opening_hours[i] + '</li>';

		html = '<li><a href="' + place.url + '" target="_blank">' + address + '</a></li>' + '<li>' + phone + '</li>' + '<li><a target="_blank" href="' + website + '">' + website + '</a></li>' + '<li class="opening-hours"><ul>' + hours_string + '</ul>';

		return html;
	}

	handle_accordion_click() {
		var _this = this;
		$(document).on('click', '.amenities-list .side-nav-item > a', function (e) {
			e.preventDefault();
			var $parent = $(this).parent();
			$parent.addClass('cat-parent-open').siblings().removeClass('cat-parent-open');
			var $sub_list = $parent.find('.sub-list');

			if ($sub_list.hasClass('expanded')) {
				$sub_list.slideUp(300, function () {
					$(this).removeClass('expanded');
					$(this).closest('li').removeClass('cat-parent-open');
					$(this).parent().find('> a > i').removeClass('minus');
				});
			} else {
				if (_this.active_category) {
					_this.active_category.removeClass('expanded');
					_this.active_category.parent().find('> a > i').removeClass('minus');
					_this.active_category.slideUp(300);
				}
				$sub_list.slideDown(300, function () {
					$(this).addClass('expanded');
					$(this).parent().find('> a > i').addClass('minus');
					_this.active_category = $sub_list;
				});
			}
		});
	}

	handle_amenity_click() {
		var _this = this;
		$(document).on('click', '.amenity-list-item .amenity', function (e) {
			e.preventDefault();

			var $elem = $(this).parent();
			var $parent = $(this).parent().parent();
			var $place_details = $elem.find('.place-details');
			var place_id = $(this).parent().attr('place-id');

			var service = new google.maps.places.PlacesService(document.createElement('div'));

			service.getDetails({
				placeId: place_id
			}, function (place, status) {
				if (status === google.maps.places.PlacesServiceStatus.OK) {
					var html = _this.get_place_html(place);
					$place_details.html(html);
				}
			});
			if ($place_details.hasClass('expanded')) {
				$place_details.slideUp(150, function () {
					$(this).removeClass('expanded');
					$elem.removeClass('expanded');
					$elem.find('.amenity > i').removeClass('minus');
				});
			} else {
				$place_details.slideDown(150, function () {
					$(this).addClass('expanded');
					$elem.addClass('expanded');
					$elem.find('.amenity > i').addClass('minus');
				});
			}
		});
	}
}

module.exports = AmenityAccordion;